import { Box, Button, Card, IconButton, InputLabel, Menu, MenuItem, Modal, Stack, TextField, Typography, useTheme } from "@mui/material"
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { authViaJwt, invoiceStatusRead, resendInvoice, supplierDocuments, updateInvoice } from "../Supplier"
import { DataGrid } from "@mui/x-data-grid"
import moment from "moment"
import { DatePicker } from "@mui/x-date-pickers"
import UnsubscribeIcon from '@mui/icons-material/Unsubscribe';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CryptoJS from "crypto-js"
import { isExpired, decodeToken } from "react-jwt";
import Label from "../components/label"



const Page =()=>{
   
    const theme = useTheme()
    const cols =[
    {field:'status',headerName:'Etat',renderCell:(value)=>
      
      value.row.status!='sent'?
        
             <UnsubscribeIcon  color="error"/> 
        :
             <MarkEmailReadIcon color="success"/> 
     
    },
    {field:'sendDate',headerName:'Envoyé',valueFormatter:(value)=>{console.log("VV",value); return(moment(value).format('DD/MM/YYYY HH:mm'))},flex:0.5},
    {field:'docNumber',headerName:'Numéro de document',flex:1},
    {field:'numTva',headerName:'Numéro de T.V.A',flex:1},
    {field:'customerName',headerName:'Client',flex:1},
    {field:'transmissionId',headerName:"Numero d'envoi",flex:1,valueGetter:(value,row)=>row.transmissionId?row.transmissionId:row.peppolId?row.peppolId:row.remarque},
    {field:'actions',headerName:'',renderCell:(value,row)=>
        value.row.status!='sent'?
        <ActionsCell {...value}/>
        :
        <></>
        },
    
]
    
    const [searchParams]=useSearchParams()
    const [dates,setDates]=useState({from:moment().startOf("month"),to:moment()})
    const [newTva,setNewTva]=useState({id:null,value:null})
    const [invoices,setInvoices]=useState([])
    const [refresh,setRefresh]=useState(null)
    const [authorization,setAuthorization]=useState({auth:null,token:null})
    const apiKey = searchParams.get("key")
    console.log(apiKey)
    const updateTva=(id,tva)=>{
      updateInvoice(id,tva).then(e=>console.log("UPDATED")).catch(e=>console.log("ERROR"))
    }
    function ActionsCell(params) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const resend=(id)=>{
    console.log("RESEND",authorization)
    resendInvoice(id,authorization.token).then(setRefresh(moment)).catch(e=>console.log(e))
  }
 
  const verify =(id)=>{
          console.log("Check",authorization.token,id)
         
          invoiceStatusRead(authorization.token,id).then(
              data=>{console.log(data)}
          ).catch(e=>console.log(e))
      }
  return (
    params.row.status!='sent'?
    <>
      <IconButton size="small" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => { handleClose();setNewTva({id:params.row.id,value:params.row.numTva}) }}>Éditer</MenuItem>
        <MenuItem onClick={() => { handleClose();resend(params.row.id) }}>Renvoyer</MenuItem>
        <MenuItem onClick={() => { handleClose(); alert(`Supprimer ${params.row.id}`); }}>Supprimer</MenuItem>
        <MenuItem onClick={() => { handleClose(); alert(`${params.row.remarque}`); }}>Voir détails</MenuItem>
        <MenuItem onClick={()=>{handleClose();verify(params.row.peppolId)}}>Verifier le statut</MenuItem>
      </Menu>
    </>
    :
    <></>
  );
}
  useEffect(()=>{
   
    if(apiKey){
      //try to auth 
      authViaJwt(apiKey).then(data=>{
        data=data[1]
        console.log("DD",data)
        setAuthorization({auth:true,token:data.api,name:data.name})
      }).catch(e=>{console.log(e)
        setAuthorization({auth:false})})
    }
  },[apiKey])  
  useEffect(()=>{
        if(authorization.auth){
                        supplierDocuments(authorization.token,moment(dates.from).format("YYYYMMDD"),moment(dates.to).format("YYYYMMDD")).then(data=>{
                          console.log("ALLDATA",data)
                            let _data = data.filter(e=>e[7])

                            var dataSorted =_data.sort((a, b) => new Date(b[1]) - new Date(a[1]))
                            
                            updateInvoices(dataSorted)

                           })

        }
    },[authorization,refresh])
     const verifyAll=async()=>{
      for(var i = 0;i<invoices.length;i++){
        await invoiceStatusRead(authorization.token,invoices[i].peppolId)
      }
      setRefresh(moment())
  }
    const updateInvoices=async (data)=>{
        console.log(data)
        let _oldInvoice=data
        for (var i=0;i<_oldInvoice.length;i++){
          
            if(!_oldInvoice[i][2]){
                  console.log(_oldInvoice[i][2],_oldInvoice[i][0])
                 await invoiceStatusRead(apiKey,_oldInvoice[i][0]).then(
                        data=>{console.log("DATA",data.response.status);
                            if(data.response.status===200){
                            _oldInvoice[i][2]=data.data.attributes?.status||null
                            _oldInvoice[i][3]=data.data.attributes?.transmissionId||null
                            _oldInvoice[i][4]=data.data.attributes?.transmissionId||null
                            }
                            else{
                               _oldInvoice[i][2]="unknow"
                            }
                        }
                    ).catch(e=>console.log(e))
                }
            }
            setInvoices(_oldInvoice.map(e=>({id:e[8],sendDate:e[1],status:e[2],transmissionId:e[3],remarque:e[4],numTva:e[5],customerName:e[6],docNumber:e[7],peppolId:e[0]})))
        }
    

    if(authorization.auth===null){
      return(
        <Typography variant="h2">Authentification en cours</Typography>
      )
    }
    if(authorization.auth===false){
      return(
        <Typography variant="h2">Authentification impossible clé invalide</Typography>
      )
    }
    
    return(
     
        <Box style={{ display: 'flex', flex: 1, minHeight: '100vh', flexDirection: 'column',margin:0,marginTop:0 }}>
          <Modal sx={{display:'flex',justifyContent:'center',alignItems:'center'}}  open={newTva.id?true:false}>
            <Card sx={{backgroundColor:'white',padding:'10px'}}>
            <InputLabel>Numéro de TVA</InputLabel>
            <TextField onChange={e=>setNewTva({...newTva,value:e.target.value})} value={newTva.value}/>
            <Box direction={'row'} sx={{display:'flex',marginTop:'10px',justifyContent:'space-between'}}>
              <Button onClick={()=>setNewTva({id:null,value:null})} >Annuler</Button>
              <Button onClick={()=>{
                updateInvoice(newTva.id,newTva.value).then(d=>
                  {
                    setRefresh(moment())
                    
                    setNewTva({id:null,value:null})})
              }} variant='contained'>Valider</Button>
            </Box>
            </Card>
          </Modal>
          <Box sx={{backgroundColor:'#0e0d2b',padding:"10px",paddingLeft:'15px',display:'flex',justifyContent:'space-between',alignItems:'center'}} spacing={2} direction='row' >
                  <Typography sx={{color:"white"}} variant="h3">H&H Informatique</Typography>
                  <Typography sx={{color:"white"}} >support@hhinformatique.be</Typography>
          </Box>
           
                
                
               
              <Box sx={{ flexGrow:1,background:'white',padding:5, display: 'flex',height:'100%',minHeight:'100%',flexWrap:'wrap',flexDirection:'column' }}>
                 <Stack direction={'row'} sx={{alignItems:'center'}} padding={2} spacing={2}>
                    <Typography>Du </Typography>
                    <DatePicker onChange={(e)=>setDates({...dates,from:e})} value={dates.from}/>
                    <Typography> au </Typography>
                    <DatePicker onChange={(e)=>setDates({...dates,to:e})}  value={dates.to}/>
                    <Button onClick={()=>setRefresh(moment())}>Rechercher</Button>
                    <Button onClick={()=>verifyAll()}>Rafraichir les statuts</Button>
                 </Stack>
                 <Typography>{`liste des factures envoyées via peppol pour la période du ${moment(dates.from).format("DD/MM/YYYY")} au ${moment(dates.to).format("DD/MM/YYYY")}`}</Typography>
            <DataGrid
              
              sx={{flex:1,display:'flex',height: '100vh' }}
                rows={invoices}
                autoPageSize
                columns={cols}
                pagination
                pageSizeOptions={[5, 10, 25, 50, 100]}
            >
                
            </DataGrid>
            </Box>
       
        </Box>
        
    )

}

export default Page